import axios from "axios";
import { ip_back } from "../../config.js";

const Login = async (email, password, lng) => {
  const params = {
    email: email,
    password: password,
  };
  try {
    const response = await axios.post(
      `${ip_back}api/user/login`,
      params,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": lng,
        },
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

const Register = async (file, data) => {
  const params = new FormData();
  params.append("user_image", file);
  params.append("email", data.email);
  params.append("password", data.password);
  params.append("firstName", data.fname);
  params.append("lastName", data.lname);
  params.append("sex", data.gender || data.sex || "male"); // Map gender to sex
  params.append("dateBorn", data.bday);
  params.append("height", data.height || "");
  params.append("weight", data.weight || "");
  params.append("user_alias", data.alias || "");
  params.append("club_id", data.club_id);
  params.append("typeUser_id", data.type);

  try {
    const response = await axios.post(
      `${ip_back}api/user/newUser`,
      params,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

// Check email availability and send confirmation email
const checkEmailAndSendConfirmation = async (email, clubData = null) => {
  try {
    const requestData = { email };
    
    // Player signup only sends a club id so the validation email can use the
    // club brand. A full club-admin payload still goes through as clubData.
    if (clubData) {
      const keys = Object.keys(clubData);
      const playerClubOnly =
        keys.length > 0 && keys.every((key) => key === "clubId" || key === "club_id");
      if (playerClubOnly) {
        requestData.clubId = clubData.clubId || clubData.club_id;
      } else {
        requestData.clubData = clubData;
      }
    }
    
    const response = await axios.post(
      `${ip_back}api/user/checkEmail`,
      requestData,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
    return response;
  } catch (error) {
    // Preserve the original error structure for better error handling
    if (error.response) {
      throw {
        ...error.response.data,
        status: error.response.status,
        response: error.response
      };
    } else {
      throw error;
    }
  }
};

// Complete registration with password after email confirmation
const Registerself = async (file, data) => {
  const params = {
    club_id: data.club_id || "",
    user_alias: data.user_alias || data.alias,
    email: data.email,
    password: data.password,
    firstName: data.firstName,
    lastName: data.lastName,
    sex: data.sex,
    dateBorn: data.dateBorn,
    typeUser_id: data.typeUser_id,
    confirmation_token: data.confirmation_token
  };

  try {
    const response = await axios.post(
      `${ip_back}api/user/registerUser`,
      params,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
const logout = async (token) => {
  const params = {};
  try {
    const response = await axios.post(`${ip_back}api/user/signOut`, params, {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    return response;
  } catch (error) {
    // Handle different error scenarios
    if (error.response && error.response.data) {
    throw error.response.data;
    } else if (error.response) {
      // Response exists but no data property
      throw {
        status: "error",
        message: error.message || "Logout failed",
        data: null
      };
    } else {
      // No response (network error, etc.)
      throw {
        status: "error",
        message: error.message || "Network error during logout",
        data: null
      };
    }
  }
};

export default Login;
export { Register, checkEmailAndSendConfirmation, logout, Registerself };
